var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<address class=\"flex-row\" style=\"gap: 1rem;\"><div ng-if=\"$ctrl.address.address\"><div>{{$ctrl.address.address}}</div><div>{{$ctrl.address.address2}}</div><div>{{$ctrl.address.city}}, {{$ctrl.address.state}} {{$ctrl.address.zip}}</div><div>{{$ctrl.address.country}}</div></div><div ng-if=\"$ctrl.allowEdit\"><a ng-click=\"$ctrl.openPrompt()\" class=\"pull-left\"><i class=\"fa fa-lg fa-pencil\"></i></a></div></address>";
var id1="address-info.minimal.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;